import {TranslationService} from "../services/translation.service";
import {MatDateFormats} from "@angular/material/core";

export interface DateParse {
  dateInput: string;
}
export class CustomDateFormat implements MatDateFormats {
  constructor(private translationService: TranslationService) {
  }
  private _parse: DateParse = {
    dateInput: this.translationService.getTranslation('dateFormat')
  };
  private _display = {
    dateInput: this.translationService.getTranslation('dateFormat'),
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  };

  set parse(parse: DateParse) {
    this._parse = Object.assign({}, this._parse, parse);
  }

  get parse(): DateParse {
    return this._parse;
  }

  get display() {
    return this._display;
  }

  public updateDateFormat(parse: DateParse) {
    this.parse = parse;
    this._display = Object.assign({}, this._display, {dateInput: parse.dateInput});
  }
}
